<template>
	<router-link :to="overrided ? override : to">
		<slot v-if="!overrided"></slot>
		<slot name="override" v-else>{{ overrideDefaultText }}</slot>
	</router-link>
</template>
<script>
	import { ref, computed } from "vue";
	export default {
		props: {
			to: {
				type: Object,
				default: () => {
					return { name: "mainTemplate" };
				}
			},
			override: {
				type: Object,
				default: () => {
					return { name: "mainTemplate" };
				}
			},
			overrided: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const overrideDefaultText = computed(() => {
				const d = context.slots.default();
				if (d) {
					return d[0]?.el?.textContent;
				} else {
					return "";
				}
			});

			return {
				overrideDefaultText
			};
		}
	};
</script>